import * as React from "react"
import CountryBox from "../components/CountryBox"
import { useDispatch } from "react-redux"
import { appActions, userInfoActions } from "../actions"
import { IUserInfo } from "../types/appDataTypes"
import getStepConfig from "./stepConfig"

const ActiveCountry: React.FC = () => {
    const dispatch = useDispatch();

    const onSelectHandler = async (country: IUserInfo["activeCountry"]) => {

        dispatch(userInfoActions.updateUserInfo({
            activeCountry: country
        }))

        const { nextStep } = getStepConfig()
        dispatch(appActions.gotoStep(nextStep))
        return
    }

    return (
        <div className="content content--flex-center">
            <div className="country-box-container" style={{ margin: -10 }}>
                <div>
                    <CountryBox country="SG" onClick={onSelectHandler} />
                    <CountryBox country="MY" onClick={onSelectHandler} />
                </div>
                <div>
                    <CountryBox country="TH" onClick={onSelectHandler} />
                    <CountryBox country="ID" onClick={onSelectHandler} />
                    <CountryBox country="VN" onClick={onSelectHandler} />
                </div>
            </div>
        </div>
    )
}

export default ActiveCountry